/* eslint-disable @typescript-eslint/no-explicit-any */
import { QueryResult } from '@apollo/client';
import { Exact, GetWorkoutByIdQuery, Scalars } from 'generated/graphql';
import uuid4 from 'uuid4';

export const addIds = (
  org?: QueryResult<GetWorkoutByIdQuery, Exact<{ id: Scalars['Int'] }>>['data'],
) => {
  if (!org) return;
  const v = org; //JSON.parse(JSON.stringify(org));

  v?.workout?.exercises?.forEach((v: any) => {
    if (!v) return;
    (v as any)['id'] = (v as any)['id'] || uuid4();
    (v as any).exercises?.forEach((v2: any) => {
      if (!v2) return;
      v2['id'] = v2['id'] || uuid4();
    });
  });
  return v;
};
